import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { loadStoredNextologiesSession } from "../utilities/nextologiesAuth";
import { LOGIN_PROVIDER } from "../config";
import CircularProgress from "@mui/material/CircularProgress";

/**
 * AppInitializer ensures socket and hostedNetworks are ready before rendering children.
 * Place this at the top of App.tsx, wrapping your provider/app logic.
 */
export default function AppInitializer({
  children,
}: {
  children: React.ReactNode;
}) {
  const hostedNetworks = useSelector(
    (state: any) => state.queue.hostedNetworks
  );
  // Optionally, track loading state if you fetch hostedNetworks async
  const [loading, setLoading] = useState(false);

  // Socket initialization now handled in AuthHandlers after token/provider are set

  useEffect(() => {
    // Only set loading to false when hostedNetworks are loaded
    if (
      loading &&
      hostedNetworks &&
      Array.isArray(hostedNetworks) &&
      hostedNetworks.length > 0
    ) {
      setLoading(false);
    }
  }, [hostedNetworks, loading]);

  // Show a loading spinner until hostedNetworks are loaded
  if (loading || !hostedNetworks) return null;

  return <>{children}</>;
}
